import { NgModule }               from '@angular/core';
import { FormsModule }            from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AppRoutingModule }       from '../app-routing.module';
import { ScheduleMainComponent }  from './schedule-main.component';
import { NgxMyDatePickerModule }  from 'ngx-mydatepicker';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AppRoutingModule,
    NgxMyDatePickerModule
  ],
  exports: [
    ScheduleMainComponent
  ],
  declarations: [
    ScheduleMainComponent
  ],
  providers: [  ]
})
export class ScheduleModule {}



// WEBPACK FOOTER //
// ./src/app/schedule/schedule.module.ts